export const blocksKeys = {
  base: ["blocks"],

  byHeight: (params: Record<string, number | string | undefined>) => [
    ...blocksKeys.base,
    "byHeight",
    params,
  ],

  byHeight1Million: (params: Record<string, number | string | undefined>) => [
    ...blocksKeys.base,
    "byHeight1Million",
    params,
  ],

  latest: (params: Record<string, number | string | undefined>) => [
    ...blocksKeys.base,
    "latest",
    params,
  ],
};
